import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import type { MergeCandidate } from './types';
import { SimilarityChip } from './SimilarityChip';
import { ThumbnailWithPreview } from './ThumbnailWithPreview';

interface MergeCandidateRowProps {
    item: MergeCandidate;
    label: string;
    isSelected: boolean;
    fallbackIcon: ReactNode;
}

export function MergeCandidateRow({
    item,
    label,
    isSelected,
    fallbackIcon,
}: MergeCandidateRowProps) {
    return (
        <div
            className={cn(
                'flex w-full items-center gap-3 rounded-md px-2 py-2',
                isSelected && 'bg-grey-500',
            )}
        >
            <ThumbnailWithPreview
                imageUrl={item.imageUrl}
                name={label}
                fallbackIcon={fallbackIcon}
            />
            <div className="min-w-0 flex-1">
                <p className="truncate text-sm text-white-100">{label}</p>
                {item.subLabel && (
                    <span className="mt-0.5 inline-block rounded bg-grey-500 px-1.5 py-0.5 font-mono text-xs text-grey-200">
                        {item.subLabel}
                    </span>
                )}
            </div>
            {item.score !== null && <SimilarityChip score={item.score} />}
        </div>
    );
}
